import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Crown, Lock } from "lucide-react";

export default function ResetPassword() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("A senha deve ter pelo menos 6 caracteres"); return; }
    if (password !== confirm) { toast.error("As senhas não coincidem"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Senha redefinida! Faça login com a nova senha.");
      nav("/login");
    } catch (err) {
      toast.error(apiErr(err.response?.data?.detail) || "Erro ao redefinir");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#09090b] flex items-center justify-center px-4 relative overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <img src="https://images.unsplash.com/photo-1503951914875-452162b0f3f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/90 to-black" />
      </div>
      <div className="relative w-full max-w-md bg-zinc-900/90 backdrop-blur border border-zinc-800 rounded-2xl p-8 animate-fade-up">
        <Link to="/" className="flex flex-col items-center mb-6">
          <Crown className="w-8 h-8 text-amber-400 mb-2" />
          <span className="font-display text-2xl gold-text font-bold">Barbearia Big Black</span>
        </Link>
        <h2 className="text-white font-heading text-xl font-bold mb-1 text-center">Criar nova senha</h2>
        {!token ? (
          <p className="text-red-400 text-sm mt-4 text-center" data-testid="reset-no-token">Link inválido. Solicite uma nova recuperação de senha.</p>
        ) : (
          <>
            <p className="text-zinc-400 text-sm mb-6 text-center">Defina sua nova senha de acesso.</p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label className="text-zinc-300">Nova senha</Label>
                <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="••••••••" className="mt-1 bg-zinc-800 border-zinc-700" data-testid="reset-password" />
              </div>
              <div>
                <Label className="text-zinc-300">Confirmar senha</Label>
                <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required placeholder="••••••••" className="mt-1 bg-zinc-800 border-zinc-700" data-testid="reset-confirm" />
              </div>
              <Button type="submit" disabled={loading} className="w-full bg-gradient-to-r from-amber-400 to-yellow-600 text-black font-bold rounded-full h-12 hover:brightness-110" data-testid="reset-submit">
                <Lock className="w-4 h-4 mr-2" /> {loading ? "Salvando..." : "Redefinir senha"}
              </Button>
            </form>
          </>
        )}
        <Link to="/login" className="block text-center text-zinc-500 text-sm mt-6 hover:text-amber-400">← Voltar ao login</Link>
      </div>
    </div>
  );
}
